document.addEventListener("DOMContentLoaded", function () {
    jQuery(".faq-item .accordion-plus__bg").on("click", function () {
      if (jQuery(this).next(".faq-content").is(":hidden")) {
        jQuery(this).addClass("slide-active");
        jQuery(this).find("button").attr("aria-expanded", "true");
      } else {
        jQuery(this).removeClass("slide-active");
        jQuery(this).find("button").attr("aria-expanded", "false");
      }
      jQuery(this).next(".faq-content").slideToggle();
    });
  
    jQuery(".faq-item .accordion-plus__bg").on("keydown", function (e) {
      if (e.key == "Enter" || e.key == "") {
        $(this).click();
      }
    });
  });
  